import React from 'react'
import { Button } from 'react-bootstrap'
import PropTypes from 'prop-types';
import { RequestParam } from '../../domain/models/RequestParam';

export const SkuDetailFlowButtons = ({ listener, disabled }: any) => {
    return (
        <>
            {
                listener?.onBackPressed &&
                <Button variant="link" className="float-left ml-4  mt-4"
                    onClick={listener.onBackPressed}> Regresar </Button>

            }
            {
                listener?.onContinuePressed &&
                <Button
                    disabled={disabled}
                    variant="primary" className="float-right mr-4  mt-4"
                    onClick={listener.onContinuePressed}> Continuar </Button>
            }


        </>
    )
}

export class SkuButtonFlowListener {
    onBackPressed?: () => void;
    onContinuePressed?: (param:RequestParam) => void;
    constructor({
        onBackPressed = undefined,
        onContinuePressed = undefined
    }: any) {
        this.onBackPressed = onBackPressed
        this.onContinuePressed = onContinuePressed
    }
}
SkuDetailFlowButtons.propTypes = {
    listener: PropTypes.instanceOf(SkuButtonFlowListener),
    disabled: PropTypes.bool
}